<template>
    <button class="sportips-button" @click="handleClick" :disabled="loading || disabled"
        :class="[actionButton ? 'spo-action-button' : '', secondaryActionButton ? 'spo-secondary-action-button' : '', mobileFullWidth ? 'spo-mobile-full-width' : '', fullWidth ? 'spo-full-width' : '', loading ? 'spo-loading' : '', disabled ? 'spo-disabled' : '']">
        <v-progress-circular v-if="loading" indeterminate size="20" width="2" :color="iconColor"
            class="mr-2"></v-progress-circular>
        <v-icon v-if="chevronLeft && !loading" class="chevron-left" icon="mdi-chevron-left"></v-icon>
        <v-icon :color="iconColor" v-if="icon && !loading" :icon="icon" class="mr-1"></v-icon>
        <slot v-if="!loading"></slot>
        <v-icon v-if="chevron && !loading" class="chevron" icon="mdi-chevron-right"></v-icon>
    </button>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            default: null
        },
        chevron: {
            type: Boolean,
            default: false
        },
        chevronLeft: {
            type: Boolean,
            default: false
        },
        href: {
            type: String,
            default: null
        },
        actionButton: {
            type: Boolean,
            default: false
        },
        secondaryActionButton: {
            type: Boolean,
            default: false
        },
        mobileFullWidth: {
            type: Boolean,
            default: false
        },
        fullWidth: {
            type: Boolean,
            default: false
        },
        toPage: {
            type: Object,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        backButton: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleClick() {
            if (this.backButton) {
                this.$router.go(-1);
                return;
            }

            if (this.toPage) {

                this.$router.push({ name: this.toPage });
                return;
            }
            if (this.href) {
                window.open(this.href, '_blank');
                return;
            } else {
                this.$emit('onClick');
            }

        }
    },
    computed: {
        iconColor() {
            return this.actionButton ? 'white' : this.secondaryActionButton ? 'white' : 'primary-dark';
        }
    }
}
</script>

<style lang="scss" scoped>
// media queries
@media (max-width: 768px) {
    .spo-mobile-full-width {
        width: 100%;
    }
}

@media (min-width: 769px) {
    .spo-mobile-full-width {
        width: auto;
    }
}

.spo-full-width {
    width: 100% !important;
}

.spo-loading {
    opacity: 0.7;
    cursor: not-allowed;

    &:disabled {
        pointer-events: none;
    }
}

.spo-disabled {
    opacity: 0.7;
    cursor: not-allowed;
}
</style>